import { CropperOptions } from "./cropTypes";
import Cropper from "cropperjs";

const getOldData = (cropper: Cropper) => {
    // @ts-ignore
    return cropper.canvasData as { oldLeft: number; oldTop: number };
};

export const getCropBoxData = (cropper: Cropper) => {
    const { height, width, top: _top, left: _left } = cropper.getCropBoxData();
    const { oldLeft, oldTop } = getOldData(cropper);
    // cropper js takes the container dimensions into consideration which we dont want
    const left = Math.abs(oldLeft - _left);
    const top = Math.abs(oldTop - _top);
    return { height, width, left, top };
};

export const loadCropper = (canvas: HTMLImageElement, options: CropperOptions) => {
    let cropCounter = 0;
    let lastWidth = 0;
    let lastHeight = 0;

    const _cropper = new Cropper(canvas, {
        ...options,
        cropend: () => {
            const { height, width, top, left } = getCropBoxData(_cropper);
            options.cropend && options.cropend(width, height, top, left);
            lastWidth = width;
            lastHeight = height;
        },
        crop: () => {
            const { height, width, top, left } = getCropBoxData(_cropper);
            cropCounter < 1 && options.crop && options.crop(width, height, top, left);
            cropCounter++;
        },
        cropmove: () => {
            const { height, width, top, left } = getCropBoxData(_cropper);
            options.cropmove && options.cropmove(width, height, top, left);

            if (lastWidth === width && lastHeight === height) {
                options.cropdrag && options.cropdrag(top, left);
            } else {
                options.cropresize && options.cropresize(width, height, top, left);
            }
        },
        ready: () => {
            options.ready && options.ready(_cropper);
            const { width, height } = _cropper.getCropBoxData();
            lastWidth = width;
            lastHeight = height;
        },
    });

    return { cropper: _cropper };
};
